import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { Observable } from 'rxjs';
import { PackageService } from '@services/packages/package.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { TranslateService } from '@services/translate/translate.service';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-package-editor-ibexsmart',
    templateUrl: './package-editor-ibexsmart.component.html',
    styleUrls: ['./package-editor-ibexsmart.component.scss'],
    providers: [PackageService],
    standalone: false
})
export class PackageEditorIbexsmartComponent implements OnInit, OnDestroy {

  public packageId;
  public myPackage: Models.Package;

  public messages;

  public hotelUrl = 'https://hotels.ibexfusion.com/info?lang=de&zip=';
  public hotelData = [];

  @Input() onSave: Observable<any>;
  public submitRequest = false;
  public availableLanguages;
  public generalFieldNames = ['enabled', 'disableContactWidget', 'splitContactWidget', 'matchIds', 'menuDisabled', 'hideLegal', 'feedbackRequestDisabled', 'overwritePreviewLink', 'overwriteQRCodeLink'];
  public styleFieldNames = ['isLightDesign', 'logoInHeader', 'highlightSecuredContent', 'primary', 'primaryTint', 'primaryShade', 'secondary', 'tertiary', 'headerTextColor', 'defaultFontSize', 'customCss'];
  public accountSettingsFieldsNames = ['frontendAccountsEnabled', 'frontendAccountEditingDisabled', 'displayLoginRequest', 'loginRequestText', 'allowedFrontProfiles', 'allowedChatProfiles', 'smsConfig'];
  private subscription: any;

  constructor(private route: ActivatedRoute, private snackbar: SnackbarService, private packageService: PackageService, private ts: TranslateService, private http: HttpClient) {
  }

  async ngOnInit() {
    this.messages = this.ts.get('system');
    this.packageId = this.route.snapshot.params['id'];
    this.subscription = this.onSave.subscribe(type => {
      if (type === 'ibexsmart-reload') {
        this.initPackage();
      } else if (type === 'ibexsmart') {
        this.save();
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe?.();
  }

  public async save() {
    this.myPackage = await this.packageService.update(this.myPackage._id, this.myPackage);
    this.submitRequest = false;
    this.snackbar.success(this.messages.general.savedChanges, 2000);
  }

  private async initPackage() {
    const myPackage = await this.packageService.get(this.packageId);
    this.myPackage = myPackage;
    this.availableLanguages = myPackage.availableLanguagesCached;
    if (!this.myPackage.ibexApp) {
      this.myPackage.ibexApp = new Models.PackageIbexApp();
    }

    if (this.myPackage && this.myPackage.combinedAddressCached && this.myPackage.combinedAddressCached.zip) {
      this.hotelData = <any>await this.http.get(this.hotelUrl + this.myPackage.combinedAddressCached.zip).toPromise();
      if (this.hotelData) {
        this.hotelData.sort(function(a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      }
    }
  }
}
